import { Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ModalAccionesUsuarioComponent} from '../modal-acciones-usuario/modal-acciones-usuario.component'


@Component({
  selector: 'app-componente-data5',
  templateUrl: './componente-data5.component.html',
  styleUrls: ['./componente-data5.component.scss']
})
export class ComponenteData5Component implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<ComponenteData5Component> = new Subject();
  tablavisible=false

  arraydeposts=[]
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''

  botondisabled=true
  arraydeempresas=[]


  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    this.inicializadatatables(()=>{
      this.query1(()=>{
        this.dtTrigger.next();
      })
    })
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
      // Destroy the table first
      dtInstance.destroy();
      //reload your data
      this.query1(()=>{
         // Call the dtTrigger to rerender after callback
         this.dtTrigger.next();
      })
    });
}

query1(callback){
  this.arraydeposts=[];
  let query1 = firebase.firestore().collection("users");
  
  query1.get().then((docs)=>{
    docs.forEach((doc)=>{
      this.arraydeposts.push(doc);
    })
  }).then(()=>{
    callback()
  }).catch((err)=>{
    console.log(err);
  })
}




  inicializadatatables(callback) {
    this.dtOptions = {
      // Declare the use of the extension in the dom parameter
      dom: 'Bfrtip',
      "pageLength": 200,
      scrollX: false,
   
      // Configure the buttons
      buttons: [
        'colvis',
        'excel',
        // 'columnsToggle',
        'print'
      ]
    };
    callback()
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }


  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }



  closeAlert(){
    this.alertaActiva=false
  }


  detallesUsuario(usuario){
    const modalRef = this.modalService.open(ModalAccionesUsuarioComponent);
    modalRef.componentInstance.usuario = usuario;//pasamos al modal el parámetro de usuario
  
    //para recibir data desde el modal
    modalRef.result.then((result) => {
      if (result=="OK") {
      this.rerender()
      }
      });
  }

 





}//fin de clase
